import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';

import {
    LOADING,
    LOAD_TIMEZONES_SUCCESS
} from '../types';
import MessageUtils from "../../utils/MessageUtils";

export const loadTimezones = () => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/timezone`;

        axios().get(url)
            .then(response => loadTimezonesSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:timeZone.loadTimeZoneFailure')));
    };
};

const loadTimezonesSuccess = (dispatch, response) => {

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_TIMEZONES_SUCCESS, payload: response.data });
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/TimezoneActions.js